module.exports = __webpack_public_path__ + "img/btn_yellow_resting.9310cf27.webp";